import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui';

interface SnapshotModalProps {
	isOpen: boolean;
	onClose: () => void;
	snapshot?: Record<string, any>;
	entityId: string;
}

export const SnapshotModal = ({ isOpen, onClose, snapshot, entityId }: SnapshotModalProps) => (
	<Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
		<DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
			<DialogHeader>
				<DialogTitle className="text-sm font-mono truncate">
					Snapshot — {entityId}
				</DialogTitle>
			</DialogHeader>
			<div className="overflow-auto flex-1 rounded-md bg-muted p-4">
				<pre className="text-xs font-mono whitespace-pre-wrap break-all text-muted-foreground">
					{snapshot ? JSON.stringify(snapshot, null, 2) : 'Aucun snapshot disponible'}
				</pre>
			</div>
		</DialogContent>
	</Dialog>
);
